<script setup lang="js">
import { useStorage } from '@vueuse/core'

const orderConfirm = useStorage('spotOrderConfirm', 0)
</script>

<template>
  <common-x-modal :title="$t('交易权限设置')" hide-actions>
    <div class="mt-3">
      <div class="py-4 flex items-center justify-between text-base">
        <div>{{ $t('下单确认') }}</div>
        <common-x-switch v-model:value="orderConfirm" :checked-value="1" :unchecked-value="0" />
      </div>
    </div>
  </common-x-modal>
</template>
